import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-date-selection',
  templateUrl: './date-selection.component.html',
  styleUrls: ['./date-selection.component.scss'],
})
export class DateSelectionComponent implements OnInit {

  @Input() placeHolder = '';
  @Input() inputClass = '';
  // @Input() ngClass = '';
  @Input() valToUpdate;
  @Input() disable = false;
  @Input() minDate = '';
  @Input() maxDate = '';
  @Output() valToUpdateChange = new EventEmitter();
  @Output() itemSelected = new EventEmitter();
  @Output() onEnterPressed = new EventEmitter();

  constructor() {
   }

  ngOnInit() {}

  onValueChanged(fromselect=false) {
    this.valToUpdateChange.emit(this.valToUpdate);
  }

  // typeahedItemSelected(item) {
  //   this.valToUpdate = item && item.orgItem;
  //   this.onValueChanged();
  //   this.itemSelected.emit(this.valToUpdate);
  // }

}
